import React from 'react';
import { Modal, ModalContent, Spinner } from '@nextui-org/react';

interface FullScreenLoadingProps {
  isOpen: boolean;
  message?: string;
  spinnerSize?: 'sm' | 'md' | 'lg';
  spinnerColor?: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger';
}

const FullScreenLoading: React.FC<FullScreenLoadingProps> = ({
  isOpen,
  message = 'Cargando...',
  spinnerSize = 'lg',
  spinnerColor = 'primary',
}) => {
  return (
    <Modal
      isOpen={isOpen}
      hideCloseButton
      isDismissable={false}
      className='bg-transparent z-999999 shadow-none backdrop-blur-sm backdrop-saturate-150 backdrop-brightness-50'
      size='full'
      classNames={{
        wrapper: 'w-full h-full',
        base: 'w-full h-full flex items-center justify-center',
      }}
      motionProps={{
        variants: {
          enter: {
            opacity: 1,
            transition: {
              duration: 0.3,
              ease: 'easeOut',
            },
          },
          exit: {
            opacity: 0,
            transition: {
              duration: 0.2,
              ease: 'easeIn',
            },
          },
        },
      }}
    >
      <ModalContent>
        <div className='flex flex-col items-center justify-center gap-4'>
          <Spinner size={spinnerSize} color={spinnerColor} />
          <p className='text-white text-lg font-medium'>{message}</p>
        </div>
      </ModalContent>
    </Modal>
  );
};

export default FullScreenLoading; 